"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Button, Popover } from "@filadd/phi-plus-core";
import { css } from "@filadd/phi-plus-styled-system/css";
import { token } from "@filadd/phi-plus-styled-system/tokens";
import { Bell } from "@phosphor-icons/react";
import { useNotificationCount } from "../hooks";
import { LazyNotificationsList } from "./NotificationsList";
import { useListenNotificationStreamDocked } from "./hooks";
export const NotificationsDock = ({ t }) => {
    const notificationCountQuery = useNotificationCount();
    useListenNotificationStreamDocked();
    return (_jsxs(Popover.Root, { positioning: { placement: "bottom-end", fitViewport: true, slide: true }, children: [_jsx(Popover.Trigger, { asChild: true, children: _jsxs(Button, { variant: "ghost", className: css({
                        p: 0,
                        paddingBlock: 0,
                        paddingInline: 0,
                        minWidth: "auto",
                        minHeight: "auto",
                        position: "relative",
                        "& svg": {
                            height: 10,
                            width: 10,
                        },
                    }), children: [_jsx(Bell, { weight: "duotone", color: token("colors.primary") }), notificationCountQuery.isSuccess &&
                            notificationCountQuery.data > 0 ? (_jsx(Badge, { variant: "solid", size: "sm", className: css({
                                position: "absolute",
                                bottom: -1,
                                right: -1,
                                borderWidth: 0,
                            }), children: notificationCountQuery.data })) : null] }) }), _jsx(Popover.Positioner, { children: _jsx(LazyNotificationsList, { t: t }) })] }));
};
NotificationsDock.prefetchQueries = (queryClient) => useNotificationCount.prefetchQuery(queryClient);
//# sourceMappingURL=NotificationsDock.js.map